jQuery(function ($) {
  const appUrl = window["app_url"];
  const resetPassSuccessMess = $("#reset_pass_success_mess");
  const customerSig = window["customer_sig"] || "";
  const customerId = window["customer_id"] || "";

  // reset password form
  const frmResetPassword = $('#frm_reset_password');
  const frmResetPasswordErrorWrapper = frmResetPassword.find('#form-reset-password-error');
  const frmResetPasswordErrors = frmResetPasswordErrorWrapper.find('.errors');
  const btnResetPassword = frmResetPassword.find('button');
  const btnResetPasswordText = btnResetPassword.text();
  let currentResetPasswordRequest = null;

  // define from validator
  frmResetPassword.validate({
    rules: {
      verifycode: "required",
      new_password: {
        required: true,
        pwcheck: true,
        minlength: 6,
      },
      confirm_new_password: {
        equalTo: "#new_password"
      }
    },
    messages: {
      new_password: {
        pwcheck: "Password must at least 6 characters and contain number(s), lower case character(s), upper case character(s) and special character(s)."
      }
    }
  });

  frmResetPassword.on("submit", function (e) {
    e.preventDefault();
    frmResetPasswordErrorWrapper.hide();
    frmResetPasswordErrors.html("");

    // check form is valid
    if (!frmResetPassword.valid()) {
      return;
    }

    const verifycode = frmResetPassword.find('input#verifycode').val();
    const newPassword = frmResetPassword.find('input#new_password').val();
    const postData = {
      "customer_id": customerId,
      "customer_sig": customerSig,
      "old_password": verifycode,
      "new_password": newPassword
    };

    currentResetPasswordRequest = $.ajax({
      type: frmResetPassword.attr('method'),
      url: appUrl + '/customer/change-password',
      data: JSON.stringify(postData),
      contentType: "application/json; charset=utf-8",
      beforeSend: function () {
        if (currentResetPasswordRequest != null) {
          currentResetPasswordRequest.abort();
        }

        btnResetPassword.attr('disabled', true);
        btnResetPassword.text('Processing ...');
      },
      success: function (res) {
        if (res.success) {
          resetPassSuccessMess.show();

          // logout user & redirect to login page
          let logoutUrl = '/account/logout';
          let loginUrl = '/account/login';
          fetch(logoutUrl).then(() => location.href = loginUrl);
        } else {
          const errorsHtml = '<ul>' +
            ' <li>' + res.message + '</li>' +
            '</ul>';

          frmResetPasswordErrors.html(errorsHtml);
          frmResetPasswordErrorWrapper.show();
        }
      },
      error: function (xhr, ajaxOptions, thrownError) {
        const res = xhr.responseJSON;
        const errorsHtml = '<ul>' +
          ' <li>' + res.message + '</li>' +
          '</ul>';

        frmResetPasswordErrors.html(errorsHtml);
        frmResetPasswordErrorWrapper.show();
        $('html, body').animate({
          scrollTop: 0
        }, 500);
      },
      complete: function (res) {
        btnResetPassword.text(btnResetPasswordText);
        btnResetPassword.removeAttr('disabled');
      }
    });
  });

  $.validator.addMethod("pwcheck", function (value) {
    return /[0-9]+/.test(value) // has a lowercase letter
      && /[a-z]+/.test(value) // has a lowercase letter
      && /[A-Z]+/.test(value) // has a lowercase letter
      && /[^a-zA-Z0-9]+/.test(value) // has a lowercase letter
  });
});
